<div class="layer-details-pane clearfix">
    <div *ngIf="esriLayer.mapcoreProps && esriLayer.mapcoreProps.category || (esriLayer.mapcoreProps.tableNames && esriLayer.mapcoreProps.tableNames.length)">
        <strong title="Category">{{ esriLayer.mapcoreProps.category || 'Tables' }}:</strong>
        <ul title="Tables">
            <li *ngFor="let name of esriLayer.mapcoreProps.tableNames">{{ name }}</li>
        </ul>
    </div>
    <div *ngIf="esriLayer.mapcoreProps && esriLayer.mapcoreProps.description">
        <strong>Description:</strong><br />
        <p>{{ esriLayer.mapcoreProps.description }}</p>
    </div>
    <div *ngIf="esriLayer.mapcoreProps && esriLayer.mapcoreProps.url">
        <strong>URL:</strong><br />
        <p><a href="{{ esriLayer.mapcoreProps.url }}" target="_blank">{{ esriLayer.mapcoreProps.url }}</a></p>
    </div>
    <div *ngIf="maximumRecordUpdateDate" title="The maximum date of the layer table's recordUpdate field.">
        <strong>Records Last Updated:</strong> {{ maximumRecordUpdateDate }}
    </div>
    <div *ngIf="recordCount !== null" title="Unfiltered Record Count">
        <strong>Total Records:</strong> {{ recordCount }}
    </div>
    <div *ngIf="filterRecordCount !== null" title="Filtered Record Count">
        <strong>Filtered Records:</strong> {{ filterRecordCount }}
    </div>
    <div *ngIf="simpleQuery" title="Layer Query">
        <strong>Query:</strong><br />
        {{ simpleQuery }}
    </div>
    <div *ngIf="sqlQuery" title="Layer SQL">
        <strong>SQL Query:</strong><br />
        {{ sqlQuery }}
    </div>
</div>
